// extracted by mini-css-extract-plugin
export var productImage = "_vz-0";